<div class="relative">
  <div
    class="fixed top-5 left-0 z-[-1] w-full text-[30px] font-semibold flex gap-3 justify-center items-center ig-color-picker-shadow">
    {{getActiveWidget()?.title}}

    <div class="flex justify-center items-center bg-gray-800 w-8 h-8 rounded-full cursor-pointer"
      #wrapMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" matTooltip="Manage multiple widgets">
      <!-- <ig-expand-indicator aria-label="open" matTooltip="Manage multiple widgets"></ig-expand-indicator> -->

      <mat-icon class="text-[20px] text-white !w-5 !h-5 !overflow-visible font-normal"
        style="-webkit-text-stroke:0 white">
        expand_more
      </mat-icon>
    </div>
  </div>

  <mat-menu #menu="matMenu" class="ig-iti-create !rounded-2xl px-6 py-4">
    <div class="flex justify-between items-center pb-3">
      <div class="text-xl font-semibold text-gray-600" igClickStopPropagation>
        Manage Multiple Widgets
        <p class="text-xs text-gray-400 font-normal !mt-2">
          Easily create multiple itinerary list widgets, each with unique background images, text, and curated
          itineraries
          tailored to different themes. Whether it's historical and cultural journeys, foodie adventures, or scenic
          sightseeing
          tours, you can customize widgets to enhance your pages with diverse travel experiences.
        </p>
      </div>
      <!-- <mat-icon
        class="text-gray-600 text-[14px] border-[1px] border-gray-600 flex items-center justify-center !w-4 !h-4 rounded-full cursor-pointer">
        close
      </mat-icon> -->
    </div>

    <div class="max-h-[50vh] overflow-auto pr-3" igClickStopPropagation>
      <ul *ngIf="!isAddingWidget">
        @for (widget of _widgets; track $index) {
        <li class="flex justify-between items-center group hover:bg-gray-100 px-2 py-1 rounded cursor-pointer"
          (click)="enterWidget(widget.code)"
          matTooltip="{{ getItineraryCount(widget.code) }} itineraries in this widget" matTooltipPosition="above">
          <span>{{ widget.title }}
            <mat-icon *ngIf="isWidgetActive(widget.code)"
              class="!h-5 !w-5 text-[20px] leading-6 text-green-500 ml-2">check</mat-icon>
          </span>
          <div class="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
            <mat-icon *ngIf="!isWidgetActive(widget.code)"
              class="!w-5 !h-4 text-[18px] text-gray-500 cursor-pointer hover:text-blue-500"
              (click)="enterWidget(widget.code)" igClickStopPropagation matTooltip="Enter this widget">login</mat-icon>

            <mat-icon class="!w-5 !h-4 text-[18px] text-gray-500 cursor-pointer hover:text-blue-500"
              [matMenuTriggerFor]="linkMenu" igClickStopPropagation matTooltip="Get link">link</mat-icon>

            <mat-menu #linkMenu="matMenu" class="!p-3 ig-text-color-edit">
              <div class="flex gap-0 flex-col">
                <p class="font-semibold text-md !mb-2">Itinerary Link</p>
                <p class="text-sm">{{ getWidgetUrl(widget.code) }}</p>
                <div class="cursor-pointer underline text-blue-500 mt-1 text-sm" (click)="copyWidgetLink(widget.code)">
                  Copy to Clipboard </div>
              </div>
            </mat-menu>

            <mat-icon class="!w-5 !h-4 text-[18px] text-gray-500 cursor-pointer hover:text-red-500"
              [class.ig-hide]="!$index" [class.!max-w-[0px]]="!$index" [matMenuTriggerFor]="deleteMenu"
              #menuTrigger="matMenuTrigger" (click)="$event.stopPropagation(); activeDeleteIndex = $index"
              igClickStopPropagation matTooltip="Delete this widget">delete</mat-icon>

            <mat-menu #deleteMenu="matMenu" class="ig-confirm-menu !p-3">
              <div class="flex flex-col gap-2">
                <p class="text-sm font-medium">
                  <mat-icon class="text-red-400 translate-y-1.5 mr-1">warning</mat-icon>
                  Are you sure you want to remove this widget? All itineraries that are
                  only in this widget will be moved to the default
                  widget after deletion.
                </p>
                <div class="flex gap-2 justify-end">
                  <button mat-menu-item
                    class="!text-sm !bg-red-400 !text-white !w-[100px] !text-center !rounded-[4px] !min-h-[unset] !h-8 !mt-2"
                    (click)="deleteWidgetConfirmed()">DELETE</button>
                  <button mat-menu-item
                    class="!text-gray-600 !bg-gray-200 !text-center !min-h-[unset] !h-8 !w-[100px] !mt-2 !rounded-sm"
                    (click)="activeDeleteIndex = null;menuTrigger.closeMenu();$event.stopPropagation()">CANCEL</button>
                </div>
              </div>
            </mat-menu>
          </div>
        </li>
        }
      </ul>

      <div *ngIf="isAddingWidget" class="mt-4">
        <ig-field [control]="form.get('title')" (keydown.tab)="$event.stopPropagation()" label="Title" [maxlength]="100"
          icon="title" igClickStopPropagation></ig-field>
        <mat-error *ngIf="form.get('title').hasError('nameExists')" class="-translate-y-4 !text-xs">
          ⚠️ This name already exists. Please choose a different one.
        </mat-error>
        <div class="flex gap-3 justify-between mb-1">
          <button #menuTrigger="matMenuTrigger" [disabled]="form.invalid"
            class="flex-[1] w-half !bg-blue-400 !text-white py-2 rounded-sm hover:shadow-md"
            [matMenuTriggerFor]="createConfirmMenu">CREATE</button>
          <button
            class="flex-[1] w-half bg-gray-200 text-gray-600 py-2 shadow-sm rounded-sm transition-all duration-75 hover:shadow-md"
            (click)="isAddingWidget = false">CANCEL</button>

          <mat-menu #createConfirmMenu="matMenu" class="ig-iti-create">
            <div class="p-3 text-sm" igClickStopPropagation>
              <b>The selected name for the widget is "{{form.get('title').value}}"</b>
              <p class="mb-2">
                ⚠️
                Please note that once the name is confirmed, it cannot be changed to avoid having to update the embedded
                script and your hosting page.
              </p>
              <div class="flex gap-2 justify-end w-full">
                <button mat-menu-item
                  class="!text-white !bg-blue-400 !text-center !min-h-[unset] !h-8 !w-[100px] !mt-2 !rounded-sm"
                  (click)="create($event)">CONFIRM</button>
                <button mat-menu-item
                  class="!text-gray-600 !bg-gray-200 !text-center !min-h-[unset] !h-8 !w-[100px] !mt-2 !rounded-sm"
                  (click)="menuTrigger.closeMenu();">CANCEL</button>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>
      <div *ngIf="!isAddingWidget"
        class="mt-3 cursor-pointer bg-[#41abf3] py-1.5 text-white rounded-sm text-center uppercase"
        (click)="isAddingWidget = true">Create a New Widget</div>
    </div>

    <!-- <div class="mt-3 mb-1" igClickStopPropagation>
      <ig-button cls="w-full" (trigger)="submit($event, menuTrigger)" [isAsync]="true" [successText]="
          itinerary
            ? 'Itinerary information updated!'
            : 'Itinerary created successfully!'
        " igClickStopPropagation [disabled]="isFormInValid">{{ itinerary ? "Update" : "Create" }}
      </ig-button>
    </div> -->
  </mat-menu>
</div>